import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Toggle, Typography } from '@one-thd/sui-atomic-components';

const { bool, func } = PropTypes;

const FreeDeliveryToggle = ({ isChecked, onToggle }) => {
  return (
    <label
      className={classNames(
        'sui-inline-flex sui-align-middle sui-ml-[-7px] sui-mr-[16px]',
        'sui-text-primary sui-cursor-pointer sui-tap-highlight-transparent sui-items-center'
      )}
    >
      <Toggle
        checked={isChecked}
        onChange={() => onToggle(!isChecked)}
      />
      <Typography variant="body-base" component="span">
        <span className="sui-pl-1 sui-text-success">FREE</span> Delivery
      </Typography>
    </label>
  );
};

FreeDeliveryToggle.propTypes = {
  isChecked: bool.isRequired,
  onToggle: func.isRequired
};

export { FreeDeliveryToggle };